import React from 'react'
import { css } from '@emotion/react'
import { string, shape, object } from 'prop-types'
import { LocalImage } from '@/components/LocalImage'
import {
  SpacingToken,
  RadiusToken,
} from '@livechat/design-system-react-components'

const logoWrapperCss = css`
  display: flex;
  min-width: var(${SpacingToken.Spacing14});
  height: var(${SpacingToken.Spacing14});
  align-items: center;
  justify-content: center;
  border-radius: var(${RadiusToken.Radius2});
  padding: var(${SpacingToken.Spacing2}) 0;
  margin-right: var(${SpacingToken.Spacing5});
  margin-bottom: var(${SpacingToken.Spacing1});
  transition: all 0.2s ease-out;
`

const logoCss = css`
  max-height: var(${SpacingToken.Spacing14});
  max-width: var(${SpacingToken.Spacing14});
`

const Icon = ({ icons, logo, className, alt }) => (
  <div css={logoWrapperCss} className={className}>
    <LocalImage
      image={logo}
      alt={alt || icons?.title || ''}
      css={logoCss}
      fallback="fallbackThumbnail"
      fallbackUrl={icons?.small || icons?.original}
      strategy="lazy"
    />
  </div>
)

Icon.propTypes = {
  icons: shape({
    original: string,
    small: string,
    large: string,
    title: string,
  }),
  logo: shape({
    childImageSharp: shape({
      gatsbyImageData: object,
    }),
  }),
  className: string,
  alt: string,
}

export default Icon
